import { Button, Checkbox, FormControl, FormControlLabel, FormLabel, Grid, makeStyles, Radio, RadioGroup } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import UserCard from "../../components/userCard";
import config from "../../config";
import { dispatch, eventListener, removeEventListener } from "../../events";
import { types } from "../../events/loader";
import { types as userTypes } from "../../events/user";
import httpUtils from "../../utils/http.utils";

const useStyles = makeStyles((theme) => ({
    root: {
        overflow: 'overlay',
        height: 'calc(100vh - 64px)'
    },
    form: {
        margin: '15px',
        backgroundColor: 'white'
    }
}));

const Users = () => {
    const classes = useStyles();
    const [users, _setUsers] = useState([]);
    const usersRef = React.useRef(users);
    const setUsers = data => {
        usersRef.current = data;
        _setUsers(data);
    };
    useEffect(() => {
        load({});
        eventListener(userTypes.BLOCK_USER, onDeleteUser);
        eventListener(userTypes.DELETE_USER_REPORTS, onDeleteUser);
        return () => {
            removeEventListener(userTypes.BLOCK_USER, onDeleteUser)
            removeEventListener(userTypes.DELETE_USER_REPORTS, onDeleteUser)
        }
    }, [])

    const [server, setServer] = React.useState('USA');
    const handleServerChange = (event) => {
        setServer(event.target.value);
        localStorage.setItem('server', event.target.value);
        load({ reset: true, reported });
    };

    const [reported, setReported] = React.useState(false);
    const handleReportedChange = (event) => {
        setReported(event.target.checked);
        load({ reset: true, reported: event.target.checked });
    };

    const load = async ({ reset = false, reported = false }) => {
        dispatch(types.SET_LOADER);

        const offset = reset ? 0 : users.length;
        const results = (await httpUtils.get(`${config.BACK_API}/api/user`,
            { offset, limit: 10, reported, blocked: false }
        )).data.results;

        setUsers([...(reset ? [] : users), ...results.map(u => ({ ...u, reported }))]);
        dispatch(types.UNSET_LOADER);
    }

    const onDeleteUser = (event) => {
        setUsers(usersRef.current.filter(u => u.id !== event.values.user.id));
    }

    return (
        <Grid container spacing={3} className={classes.root} >
            <Grid item xs={12} sm={12} className={classes.form}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">Server</FormLabel>
                    <RadioGroup aria-label="gender" name="server" value={server} onChange={handleServerChange}>
                        <FormControlLabel value="USA" control={<Radio />} label="USA" />
                        <FormControlLabel value="EUROPE" control={<Radio />} label="EUROPE" />
                    </RadioGroup>
                </FormControl>
                <FormControlLabel control={<Checkbox value={reported} onChange={handleReportedChange} />} label="Reported" />
            </Grid>
            {users.map((user) => (
                <Grid item xs={12} sm={4} >
                    <UserCard user={user} />
                </Grid>
            ))}
            <Grid item xs={12} sm={12}>
                <Button variant="contained" onClick={() => load({ reported })}>Load more</Button>
            </Grid>
        </Grid >
    )
}

export default Users;